export const uiTypes = {
  setSelectedModule: '[ui] set selected module',
  addFavorite: '[ui] add favorite',
  deleteFavorite: '[ui] delete favorite',
  searchFavorite: '[ui] search favorite'
}
